export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref(false);
  const message = ref('')

  function setMessage (msg) {
    message.value = msg
  }


  function startLoading(msg?) {
    if (msg) {
      setMessage(msg)
    }
    isLoading.value = true;
  }

  function stopLoading() {
    setMessage('')
    isLoading.value = false;
  }

  return {
    isLoading,
    message,
    startLoading,
    stopLoading,
  };
});
